import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../Typography";
const StatsNumber = ({ children }) => {
    const numberFormatter = Intl.NumberFormat("pt-BR");
    if (typeof children !== "string" && typeof children !== "number")
        return children;
    return (_jsx(Typography, { variant: "button-label", className: "min-w-[18px] text-right", children: (typeof children !== "number" && numberFormatter.format(Number(children))) || children }));
};
StatsNumber.displayName = "Stats.Number";
export default StatsNumber;
